import { notification } from 'antd';
import axios from 'axios';
import {getLangValue, localize} from '../helpers';

let n = true;

const AxiosInterceptor = ({ children, translations, isError, token, hideNoDataNotification, language }) => {
    const translate = (data: string, code?: any): string => {
        const ltr = localStorage.getItem('translations');
        const translations = ltr && JSON.parse(ltr);

        return localize(data, translations, code);
    };

    if (typeof  window.localStorage !== 'undefined') {
        const ltr = localStorage.getItem('translations');
        const prevTr = ltr && JSON.parse(ltr);

        localStorage.setItem('translations', JSON.stringify({...prevTr, ...translations}));
    }

    if (n) {
        axios.interceptors.request.use(
            (config) => {
                const breadcrumbs = localStorage.getItem('breadcrumbs');

                if (token) {
                    config.headers['Authorization'] = token;
                }

                if (language) {
                    config.headers['X-Portal-Language'] = getLangValue(language);
                }

                if (breadcrumbs) {
                    config.headers['Breadcrumbs'] = breadcrumbs;
                }

                return config;
            },
            (error) => {
                Promise.reject(error);
            }
        );

        const getNomadError = (data: any) => {
            const {nomadErrorCode, nomadErrorMessage} = data;

            switch (nomadErrorCode) {
                case "7": notification['error']({
                    message: translate('error'),
                    description: translate('error.nomad-error-7'),
                }); break;
                default: notification['error']({
                    message: translate('error'),
                    description: nomadErrorMessage,
                });
            }
        };

        const getTranslatedError = (code) => {
            if (code) {
                return translate(code);
            }

            return translate('error.internal-server-error');
        };

        const getJsonErrorFromBlob = (error) => {
            const reader = new FileReader();

            reader.addEventListener('loadend', () => {
                if (typeof reader.result === 'string') {
                    try {
                        const data = JSON.parse(reader.result);

                        notification['error']({
                            message: translate('error'),
                            description: data.message,
                        });
                    } catch (e) {

                    }
                }
            });

            reader.readAsText(error.response.data);
        };

        axios.interceptors.response.use(
            (res) => {
                return res;
            },
            (error) => {
                if (error.response) {
                    if (error.response.status === 500) {
                        if (typeof error.response?.data === "string") {
                            notification['error']({
                                message: translate('error'),
                                description: translate(error.response.data),
                            });
                        } else if (error.response?.data?.nomadErrorCode) {
                            getNomadError(error.response.data);
                        } else if (error.response?.data instanceof Blob) {
                            getJsonErrorFromBlob(error);
                        } else {
                            const {errorCode, errorMessage, message } = error.response.data;

                            notification['error']({
                                message: translate('error'),
                                description: getTranslatedError(errorCode || errorMessage || message)
                            });
                        }
                    } else if (error.response.data && error.response.data instanceof ArrayBuffer) {
                        const { status, statusText, data } = error.response;
                        const message = [status, statusText].filter(Boolean).join(' - ');

                        const decoder = new TextDecoder('utf-8');
                        const description = decoder.decode(new Uint8Array(data));

                        notification['error']({
                            message,
                            description: translate(description),
                        });
                    } else if (error.response.data && error.response.data instanceof Blob) {
                        getJsonErrorFromBlob(error);
                    } else if (isError) {
                        if (error.response.status === 401 && token) {
                            notification['error']({
                                message: translate('error.user-inactive-15-min'),
                                description: translate('error.need-re-log'),
                            });
                        } else if (error.response.status === 403) {
                            notification['warning']({
                                message: 'Доступ запрещен!',
                                description: 'Доступ к запрашиваемому действию ограничен. ' +
                                    'Пожалуйста, свяжитесь с администратором системы ' +
                                    'для получения соответствующих прав доступа.',
                            });
                        } else if (error.response.status === 409) {
                            notification['error']({
                                message: translate('error'),
                                description: translate(error.response.data),
                            });
                        } else if (Array.isArray(error.response.data)) {
                            error.response.data.forEach((x) => {
                                notification['error']({
                                    message: translate('error'),
                                    description: translate(x.message, { 0: x.code }),
                                });
                            });
                        } else {
                            if (!hideNoDataNotification) {
                                notification['error']({
                                    message: `${error.response.status} ${
                                        error.response.statusText &&
                                        '- ' + error.response.statusText
                                    }`,
                                    description:
                                        error.response.data && error.response.data.errorCode
                                            ? (error.response.data.params
                                                  ? error.response.data.params.filename + ': '
                                                  : '') + translate(error.response.data.errorCode)
                                            : error.response.data && error.response.data.errorMessage
                                            ? translate(error.response.data.errorMessage)
                                            : translate(
                                                  typeof error.response.data === 'string'
                                                      ? error.response.data
                                                      : error.response.data.message
                                                        || error.response.data.body
                                                        || JSON.stringify(error.response.data)
                                              ),
                                });
                            }
                        }
                    }
                }

                return Promise.reject(error);
            }
        );

        n = false;
    }

    return children;
};

export default AxiosInterceptor;
